"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _selectedItems = _interopRequireDefault(require("../selected-items"));
var _styles = require("../styles");
/*eslint-disable react/prop-types */

const MultiSelectTypeaheadInput = _ref => {
  let {
    selectedItems,
    placeholder,
    isOpen,
    inputValue,
    getInputProps,
    getRemoveButtonProps,
    safeToggleMenu,
    removeItem,
    itemToString,
    maxLength,
    disabled,
    containsErrors,
    actionIconsPadding,
    onKeyDown,
    inputProps
  } = _ref;
  let invisibleInput = /*#__PURE__*/_react.default.createRef();

  // Only display placeholder text when dropdown is closed and input is empty
  const displayPlaceholder = !isOpen && !inputValue;
  return /*#__PURE__*/_react.default.createElement(_styles.GreyBox, (0, _extends2.default)({
    onClick: () => {
      if (!disabled) {
        safeToggleMenu();
        !isOpen && invisibleInput.current.focus();
      }
    },
    useTypeahead: true,
    disabled: disabled,
    containsErrors: containsErrors,
    actionIconsPadding: actionIconsPadding
  }, inputProps), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      flexWrap: 'wrap'
    }
  }, selectedItems.length > 0 ? /*#__PURE__*/_react.default.createElement(_selectedItems.default, {
    items: selectedItems,
    itemToString: itemToString,
    getRemoveButtonProps: getRemoveButtonProps,
    disabled: disabled
  }) : displayPlaceholder && /*#__PURE__*/_react.default.createElement(_styles.StyledPlaceholder, null, placeholder), !disabled && /*#__PURE__*/_react.default.createElement(_styles.InvisibleInput, getInputProps({
    ref: invisibleInput,
    onKeyDown(event) {
      if (event.key === 'Backspace' && !inputValue) {
        removeItem(selectedItems[selectedItems.length - 1]);
      }
      onKeyDown(event);
    },
    maxLength: maxLength,
    containsErrors: containsErrors
  }))));
};
var _default = exports.default = MultiSelectTypeaheadInput;
MultiSelectTypeaheadInput.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "MultiSelectTypeaheadInput"
};